exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".timer-text{font-size:14px;font-weight:bold}.timer-logo-container{margin-top:10px;margin-left:11px}.timer-logo{width:auto;height:108px}.timer-msg{font-size:14px;text-align:center;margin-top:16px;margin-bottom:24px}\n", ""]);

